// extracted by mini-css-extract-plugin
export default {"notFound":"ErrorPage_notFound__f-XSX","description":"ErrorPage_description__1-mf6","btnContainer":"ErrorPage_btnContainer__FmKG9","loading":"ErrorPage_loading__76YEB"};